'use client';

import { BASE_URL } from '@/common/constants';
import Link from 'next/link';
import get from 'lodash/get';
import { checkType, formatDateVN } from '@/common/ultils';
import Image from 'next/image';

const CategoryNewsBlockHome = ({ slug, item, websiteCode, deviceType }) => {
  const handleSubmitUpView = async (id) => {
    try {
      await fetch(`${BASE_URL}/showcaseWalls/updateViews/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
    } catch {
      // alert(`Có lỗi xảy ra! ${error}`);
    }
  };

  const mainPosts = get(item, 'postss[0]');
  const smallPostss = get(item, 'postss', []).slice(1, 5);
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-sm">
      {/* Header */}
      <div
        className="title cursor-pointer"
        onClick={() => {
          handleSubmitUpView(item?.id);
        }}>
        <a href={`/${websiteCode ? `sub/${websiteCode}/` : ''}chuyen-muc/${item.slug}`} className="font-normal w-full">
          {item?.name}
        </a>
      </div>

      {/* Body */}
      {mainPosts && (
        <div className="p-4">
          {/* Main post */}
          <Link href={`${slug}/${mainPosts.slug}`} className="block group mb-4">
            {/* Thumbnail 16/9 */}
            <div className="aspect-video rounded overflow-hidden mb-2.5">
              {mainPosts?.imgaeUrls ? (
                <div className="relative w-full h-full">
                  <Image
                    src={checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', mainPosts, -1)}
                    alt={mainPosts.title}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-300 position-initial"
                  />
                </div>
              ) : (
                <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                  <Image src="/img-default.png" alt="Ảnh mặc định" width={60} height={60} className="object-cover opacity-40" />
                </div>
              )}
            </div>

            <h4 className="text-[15px] font-semibold text-gray-800 group-hover:text-[#b71c1c] line-clamp-2 leading-snug mb-1 transition-colors duration-200">
              {mainPosts.title}
            </h4>
            {!!(mainPosts?.postedDate ?? mainPosts?.date) && (
              <span className="text-[12px] text-gray-400 flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                {formatDateVN(mainPosts?.postedDate ?? mainPosts?.date)}
              </span>
            )}
          </Link>

          {/* Sub list */}
          {smallPostss.length > 0 && (
            <ul className="border-t border-gray-200 pt-2 space-y-0">
              {smallPostss.map((article) => (
                <li key={article.slug} className="flex justify-between items-start gap-3 py-2 border-b border-dashed border-gray-200 last:border-b-0">
                  <Link
                    href={`${slug}/${article.slug}`}
                    className="text-[13.5px] text-gray-700 hover:text-[#b71c1c] line-clamp-2 leading-snug flex-1 transition-colors duration-200 before:content-['›'] before:text-[#b71c1c] before:font-bold before:mr-1.5">
                    {article.title}
                  </Link>
                  {!!(article?.postedDate ?? article?.date) && (
                    <span className="text-[11px] text-gray-400 whitespace-nowrap min-w-[70px] text-right mt-0.5">
                      {formatDateVN(article?.postedDate ?? article?.date)}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryNewsBlockHome;
